import { fullCurrency } from '../../../utils/formatCurrency.js';

/** Paid amounts: green. Balance / unpaid amounts: red. Used on all dashboard money charts. */
export const CHART_PAID_COLOR = '#16a34a';
export const CHART_DUE_COLOR = '#dc2626';
export const CHART_SECONDARY_COLOR = '#2563eb';
export const CHART_NEUTRAL_COLOR = '#7c3aed';

export const PAID_DUE_PIE_COLORS = {
  paid: CHART_PAID_COLOR,
  unpaid: CHART_DUE_COLOR,
  balance: CHART_DUE_COLOR,
  completed: CHART_PAID_COLOR,
  credited: CHART_PAID_COLOR,
  active: CHART_SECONDARY_COLOR,
  pending: CHART_DUE_COLOR,
};

export function formatChartValue(value, format = 'currency') {
  const num = Number(value) || 0;
  if (format === 'hours') {
    return `${num.toFixed(1)}h`;
  }
  if (format === 'count') {
    return String(Math.round(num));
  }
  return fullCurrency(num);
}

/** Light-blue tooltip with dark text so hover labels stay readable on all charts. */
export const CHART_TOOLTIP_STYLE = {
  backgroundColor: '#EFF6FF',
  border: '1px solid #BFDBFE',
  borderRadius: 8,
  color: '#1F2937',
  fontSize: 13,
  boxShadow: '0 4px 12px rgba(37, 99, 235, 0.12)',
};

export const CHART_TOOLTIP_LABEL_STYLE = {
  color: '#111827',
  fontWeight: 600,
  marginBottom: 4,
};

export const CHART_TOOLTIP_ITEM_STYLE = {
  color: '#1F2937',
};

/** Keep Recharts' default wrapper from covering the custom tooltip. */
export const CHART_TOOLTIP_WRAPPER_PROPS = {
  contentStyle: {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: 0,
  },
  wrapperStyle: { outline: 'none', zIndex: 40 },
};

export function DashboardAmountTooltip({ active, payload, label, format = 'currency' }) {
  if (!active || !payload?.length) return null;

  const visible = payload.filter((item) => Number(item.value) > 0);
  if (!visible.length) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 shadow-md text-sm text-gray-800">
      {label ? <p className="font-semibold text-gray-900 mb-1">{label}</p> : null}
      {visible.map((item) => (
        <p key={item.dataKey || item.name} className="font-medium text-gray-800">
          <span className="inline-block w-2 h-2 rounded-full mr-1.5 align-middle" style={{ backgroundColor: item.color }} />
          {item.name} : {formatChartValue(item.value, item.payload?.valueFormat || format)}
        </p>
      ))}
    </div>
  );
}
